
import { DashboardHome } from "../../types/dashboard/dashboardHome"
import { DashboardRH } from "../../types/dashboard/dashboardRH"
import { ApiError, ApiResponse } from "../../types/global/apiTypes"
import { axiosInstance } from "../axiosInstance"
import { handleAxiosResponse } from "../handleAxiosResponse"

import handleAxiosError from "../handleAxiosError"

export const getDashboardHome = async (): Promise<ApiResponse<DashboardHome>> => {
  try {
    const response = await axiosInstance().get<DashboardHome | ApiError>(`/dashboard/home`)
    return handleAxiosResponse<DashboardHome>(response)
  } catch (error) {
    return handleAxiosError(error)
  }
}

export const getDashboardRH = async (): Promise<ApiResponse<DashboardRH>> => {
  try {
    const response = await axiosInstance().get<DashboardRH | ApiError>(`/dashboard/rh`)
    return handleAxiosResponse<DashboardRH>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}